import React from 'react'
import { List, Datagrid, TextField, Filter, TextInput, ShowButton } from 'react-admin'

const AccountFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

const AccountList = (props) => (
  <List hasCreate={false} filters={<AccountFilter />} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <ShowButton />
    </Datagrid>
  </List>
)

export default AccountList
